import { GetNearbyDropOffPointsArgs } from '../types/nearby-drop-off-point'

export const addNearbyDropOffPointArgsToParams = ({
  labelTypeId,
  countryCode,
  latitude,
  longitude,
  limit,
  labelType,
}: GetNearbyDropOffPointsArgs) => ({
  label_type_id: labelTypeId,
  label_type: labelType,
  country_code: countryCode,
  latitude,
  longitude,
  limit,
})
